import { useTranslation } from "@/hooks";
import { useSignIn, useUser } from "@/stores/auth";
import {
  Alert,
  Button,
  Flex,
  Image,
  PasswordInput,
  Stack,
  TextInput,
  Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useState } from "react";
import { Navigate } from "react-router";

export function LoginPage() {
  const user = useUser();
  const signIn = useSignIn();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const form = useForm({
    initialValues: {
      username: "",
      password: "",
    },
  });

  if (user) {
    return <Navigate to="/" replace />;
  }

  const handleSubmit = async (values: {
    username: string;
    password: string;
  }) => {
    setLoading(true);
    setError(null);

    try {
      const { error } = await signIn(values.username, values.password);

      if (error) {
        setError(error.message);
      }
    } catch (err) {
      setError(t("login").unexpectedError);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Flex
      w="100%"
      h="100vh"
      align="flex-start"
      justify="flex-start"
      bg="eu_flag.9"
    >
      <Flex
        direction="column"
        justify="center"
        align="center"
        bg="white"
        p={30}
        flex={1}
        h="100%"
        maw={500}
      >
        <Flex direction="column" justify="center" bg="white" w={400} h="100%">
          <Title order={2} ta="center" mb="md">
            Login
          </Title>
          <form onSubmit={form.onSubmit(handleSubmit)}>
            <Stack>
              {error && <Alert color="red" p={8} title={error} />}
              <TextInput
                label={t("login").username}
                placeholder={t("login").usernamePlaceholder}
                required
                {...form.getInputProps("username")}
              />
              <PasswordInput
                label={t("login").password}
                placeholder={t("login").passwordPlaceholder}
                required
                {...form.getInputProps("password")}
              />
              <Button mt="md" type="submit" fullWidth loading={loading}>
                {t("login").signIn}
              </Button>
            </Stack>
          </form>
        </Flex>
      </Flex>
      <Flex flex={1} h="100%">
        <Image
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
          src="/images/welcome.jpg"
          alt="Atlasio"
        />
      </Flex>
    </Flex>
  );
}
